var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('section', {
    class: ['activity-stage', {
      tablet: _vm.isMobile
    }]
  }, [_c('aside', [_c('figure', {
    class: ("image step-" + (_vm.currentStep.stepIndex))
  }, [_c('img', {
    attrs: {
      "src": _vm.currentStep.image
    }
  })])]), _c('text-display-list', {
    attrs: {
      "isMobileView": _vm.isMobile
    }
  }, [_c('li', {
    class: ("step step-" + (_vm.currentStep.stepIndex))
  }, [_vm.currentStep.stepIndex !== undefined ? _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentStep.answer,
      "text-step": _vm.currentStep.stepIndex
    }
  }) : _vm._e()], 1)])], 1), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }